import { KTSVG, toAbsoluteUrl } from '../_metronic/helpers'
const Loader = () => {
    return (
        <div className="app-default" data-kt-app-page-loading-enabled="true" data-kt-app-page-loading="on">
            <div className="page-loader flex-column bg-dark bg-opacity-25">
                {/* <img alt="Logo" src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')}  className="h-50px zoom-in-out-box app-sidebar-logo-default theme-light-show"/> */}
                <img alt="Logo" src={toAbsoluteUrl('/media/logos/Loader.gif')}  className="h-60px app-sidebar-logo-default theme-light-show"/>
                {/* <span className="spinner-border text-primary" role="status"></span> */}
                {/* <span className="text-gray-800 fs-6 fw-semibold mt-5">Loading...</span> */}
            </div>
        </div>
    )
}
export default Loader